import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { createContext } from "react";
import { FilesService } from "../files/index.js";
import { ImageConverter } from "../image-converter/index.js";
import { ImageRotator } from "../image-rotator/index.js";
import { Calendar } from "../calendar/index.js";
import { Logger } from "../logger/index.js";
import { FileType } from "../file-type/index.js";
import { ValidationService } from "../validation/index.js";
import { FileCache } from "../file-cache/index.js";
const ServicesContext = /*#__PURE__*/ createContext(null);
const ServicesProvider = (t0)=>{
    var _ref;
    const $ = c(33);
    const { services, children } = t0;
    let t1;
    if ($[0] !== (null == services ? void 0 : services.logger)) {
        var _ref1;
        t1 = null != (_ref1 = null == services ? void 0 : services.logger) ? _ref1 : new Logger();
        $[0] = null == services ? void 0 : services.logger;
        $[1] = t1;
    } else t1 = $[1];
    const logger = t1;
    let t2;
    if ($[2] !== logger || $[3] !== (null == services ? void 0 : services.fileType)) {
        var _ref2;
        t2 = null != (_ref2 = null == services ? void 0 : services.fileType) ? _ref2 : new FileType(logger);
        $[2] = logger;
        $[3] = null == services ? void 0 : services.fileType;
        $[4] = t2;
    } else t2 = $[4];
    const fileType = t2;
    let t3;
    if ($[5] !== fileType || $[6] !== logger || $[7] !== (null == services ? void 0 : services.fileCache)) {
        var _ref3;
        t3 = null != (_ref3 = null == services ? void 0 : services.fileCache) ? _ref3 : new FileCache(logger, fileType);
        $[5] = fileType;
        $[6] = logger;
        $[7] = null == services ? void 0 : services.fileCache;
        $[8] = t3;
    } else t3 = $[8];
    const fileCache = t3;
    let t4;
    if ($[9] !== (null == services ? void 0 : services.filesService)) {
        var _ref4;
        t4 = null != (_ref4 = null == services ? void 0 : services.filesService) ? _ref4 : new FilesService();
        $[9] = null == services ? void 0 : services.filesService;
        $[10] = t4;
    } else t4 = $[10];
    let t5;
    if ($[11] !== (null == services ? void 0 : services.imageConverter)) {
        var _ref5;
        t5 = null != (_ref5 = null == services ? void 0 : services.imageConverter) ? _ref5 : new ImageConverter();
        $[11] = null == services ? void 0 : services.imageConverter;
        $[12] = t5;
    } else t5 = $[12];
    let t6;
    if ($[13] !== (null == services ? void 0 : services.imageRotator)) {
        var _ref6;
        t6 = null != (_ref6 = null == services ? void 0 : services.imageRotator) ? _ref6 : new ImageRotator();
        $[13] = null == services ? void 0 : services.imageRotator;
        $[14] = t6;
    } else t6 = $[14];
    let t7;
    if ($[15] !== fileType || $[16] !== (null == services ? void 0 : services.validation)) {
        var _ref7;
        t7 = null != (_ref7 = null == services ? void 0 : services.validation) ? _ref7 : new ValidationService(fileType);
        $[15] = fileType;
        $[16] = null == services ? void 0 : services.validation;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== (null == services ? void 0 : services.calendar)) {
        var _ref8;
        t8 = null != (_ref8 = null == services ? void 0 : services.calendar) ? _ref8 : new Calendar();
        $[18] = null == services ? void 0 : services.calendar;
        $[19] = t8;
    } else t8 = $[19];
    const t9 = null != (_ref = null == services ? void 0 : services.pdfWorkerSrc) ? _ref : "/pdf.worker.min.js";
    let t10;
    if ($[20] !== fileCache || $[21] !== fileType || $[22] !== logger || $[23] !== t4 || $[24] !== t5 || $[25] !== t6 || $[26] !== t7 || $[27] !== t8 || $[28] !== t9) {
        t10 = {
            filesService: t4,
            imageConverter: t5,
            imageRotator: t6,
            validation: t7,
            calendar: t8,
            logger,
            fileCache,
            fileType,
            pdfWorkerSrc: t9
        };
        $[20] = fileCache;
        $[21] = fileType;
        $[22] = logger;
        $[23] = t4;
        $[24] = t5;
        $[25] = t6;
        $[26] = t7;
        $[27] = t8;
        $[28] = t9;
        $[29] = t10;
    } else t10 = $[29];
    const fullServices = t10;
    let t11;
    if ($[30] !== children || $[31] !== fullServices) {
        t11 = /*#__PURE__*/ jsx(ServicesContext.Provider, {
            value: fullServices,
            children: children
        });
        $[30] = children;
        $[31] = fullServices;
        $[32] = t11;
    } else t11 = $[32];
    return t11;
};
export { ServicesContext, ServicesProvider };
